import { declineName } from '@/lib/content/declension';

const CYRILLIC_RE = /[а-яё]/i;

const cleanName = (name) => (typeof name === 'string' ? name.trim() : '');
const isRussianName = (name) => CYRILLIC_RE.test(cleanName(name));

export const ruCountryCase = (name, caseType = 'nominative') => {
    const value = cleanName(name);
    if (!value) return '';
    return isRussianName(value) ? declineName(value, caseType) : value;
};

export const ruCountryOf = (name) => {
    const value = cleanName(name);
    if (!value) return '';
    return isRussianName(value) ? ruCountryCase(value, 'genitive') : `страны ${value}`;
};

export const ruCountryFor = (name) => {
    const value = cleanName(name);
    if (!value) return '';
    return isRussianName(value) ? `для ${ruCountryCase(value, 'genitive')}` : `для страны ${value}`;
};

export const ruCountryTo = (name) => {
    const value = cleanName(name);
    if (!value) return '';
    return isRussianName(value) ? `в ${ruCountryCase(value, 'accusative')}` : `в страну ${value}`;
};

export const ruCountryIn = (name) => {
    const value = cleanName(name);
    if (!value) return '';
    return isRussianName(value) ? `в ${ruCountryCase(value, 'prepositional')}` : `в стране ${value}`;
};

export const ruCountryBy = (name) => {
    const value = cleanName(name);
    if (!value) return '';
    return isRussianName(value) ? `по ${ruCountryCase(value, 'dative')}` : `по стране ${value}`;
};
